import * as React from 'react';
export const caretUpSvg = React.forwardRef(function caretUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.186 5.14 4.13 9.418A1 1 0 0 0 4.943 11h6.114a1 1 0 0 0 .813-1.581l-3.056-4.28a1 1 0 0 0-1.628 0Z',
    }),
  );
});
caretUpSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var caretUp = {
  category: 'icon',
  colorable: true,
  name: 'caretUp',
  svg: caretUpSvg,
};
